module.exports = __webpack_public_path__ + "static/img/default.5af96589.jpg";